<template>
    <div class="page">
        <z-entity-template ref="entityTemplateModel" @success="onTemplateSuccess"></z-entity-template>
        <div class="content">
            <div>
                <a-row type="flex" justify="start" :gutter="8">
                    <a-col>
                        <a-button @click="showAddTemplate" type="primary">
                            <a-icon type="plus"/>
                            新增
                        </a-button>
                    </a-col>
                </a-row>
            </div>
            <a-list itemLayout="horizontal" :dataSource="templates">
                <a-list-item slot="renderItem" slot-scope="item">
                    <a slot="actions" @click="editTemplate(item)">编辑</a>
                    <a slot="actions" @click="deleteTemplate(item.id)">删除</a>

                    <a-list-item-meta :description="item.description">
                        <span slot="title">{{item.name}}</span>
                        <a-avatar :shape="'square'" :size="'large'" slot="avatar" src="https://gw.alipayobjects.com/zos/rmsportal/dURIMkkrRFpPgTuzkwnB.png" />
                    </a-list-item-meta>

                    <a-row style="width:16%" v-for="subItem in item.attrs" :key="subItem.name">
                        <a-col>{{subItem.name}}</a-col>
                        <a-col v-if="subItem.inputType == 'text'">文本</a-col>
                        <a-col v-if="subItem.inputType == 'number'">数字</a-col>
                        <a-col v-if="subItem.inputType == 'date'">时间</a-col>
                        <a-col v-if="subItem.inputType == 'selectBox'">选择器</a-col>
                        <a-col v-if="subItem.inputType == 'image'">上传照片</a-col>
                    </a-row>
                </a-list-item>
            </a-list>
        </div>
    </div>
</template>

<script>
    import config from '@/config'
    import ZEntityTemplate from '@/views/supervise/EntityTemplate.vue'

    export default{
        data() {
            return {
                templates: []
            }
        },
        components:{
            ZEntityTemplate
        },
        created(){
            this.queryTemplates()
        },
        methods:{
            showAddTemplate(){
                this.$refs["entityTemplateModel"].showModel()
            },
            onTemplateSuccess(){
                this.queryTemplates()
            },
            editTemplate(template){
                this.$refs["entityTemplateModel"].showModel(this.clone(template))
            },
            deleteTemplate(templateId){
                let _this = this
                this.$http.delete(config.api.entity_template_url + "/" + templateId).then((response) => {
                    if(response.code == 0){
                        _this.$message.success('删除模板成功')
                        _this.queryTemplates()
                    }
                }).catch((err) => {
                    console.log(err)
                })
                this.queryTemplates()
            },
            queryTemplates() {
                this.$http.get(config.api.entity_template_url).then((response) => {
                    if(response.code == 0){
                        this.templates = response.result
                        console.log(this.templates)
                    }
                }).catch((err) => {
                    console.log(err)
                })
            },
            clone(obj){
                if (null == obj || "object" != typeof obj) return obj;
                if (obj instanceof Date) {
                    let copy = new Date();
                    copy.setTime(obj.getTime());
                    return copy;
                }
                if (obj instanceof Array) {
                    let copy = [];
                    var len = obj.length;
                    for (var i = 0; i < len; ++i) {
                        copy[i] = this.clone(obj[i]);
                    }
                    return copy;
                }
                if (obj instanceof Object) {
                    let copy = {};
                    for (var attr in obj) {
                        if (obj.hasOwnProperty(attr)) copy[attr] = this.clone(obj[attr]);
                    }
                    return copy;
                }
                throw new Error("Unable to copy obj! Its type isn't supported.");
            }
        }
    }
</script>